"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _HelpText = _interopRequireDefault(require("./HelpText.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var HelpText = function HelpText(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/_react["default"].createElement(_HelpText["default"], null, message);
};
HelpText.propTypes = {
  message: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = HelpText;